import React, { Component } from 'react';
import './../css/master.css';
import './../css/dispatch.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

var httpURL = '';
var queryString = require('querystring');
var lstCompany = [];
var lstSeason = [];
var lstDesignColor = [];
var dispReport = [];
var lstPoDesign = [];
var lstPOShowBuyers = [];
var lstBuyersForStatus = [];
var lstPoDetails = [];
var lstConstruction = [];
var lstYarnCount = [];
var lstWidth = [];
var lstQuality = [];
var dispReport = '';
var sortVal = "";
var COL_BPT_BPOID = 'td:eq(0)';
var COL_BPT_BPOSTYLEID = 'td:eq(1)';
var COL_BPT_BPONO = 'td:eq(2)';
var COL_BPT_SEASON = 'td:eq(3)';
var COL_BPT_DELIVERYDT = 'td:eq(4)';
var COL_BPT_BPOQUALITY = 'td:eq(5)';
var COL_BPT_STYLE = 'td:eq(6)';
var COL_BPT_COLOR = 'td:eq(7)';
var COL_BPT_QUALITYID = 'td:eq(8)';
var COL_BPT_QUALITY = 'td:eq(9)';
var COL_BPT_DESIGNCOLOR = 'td:eq(10)';
var COL_BPT_LENGTH = 'td:eq(11)';
var COL_BPT_WIDTHID = 'td:eq(12)';
var COL_BPT_WIDTH = 'td:eq(13)';
var COL_BPT_BUFFERDAYS = 'td:eq(14)';
var COL_BPT_CONSTRUCTIONID = 'td:eq(15)';
var COL_BPT_CONSTRUCTION = 'td:eq(16)';
var COL_BPT_YARNCOUNTID = 'td:eq(17)';
var COL_BPT_YARNCOUNT = 'td:eq(18)';
var COL_BPT_STATUS = 'td:eq(19)';

class DispatchSummary extends Component {
	constructor(props) {
		super(props);
		this.state = {
			company: [],
			season: [],
			designNoColor: [],
			flg: true,
			//flgPODesign : true,
			flgStyle: true,
			designImagePath: '',
			companyPo: [],
			poDesign: [],
			poShowBuyers: [],
			buyersForStatus: [],
			poDetails: [],
			deliveryDate: null,
			startDate: null,
			endDate: null,
			minDate: moment(),
			loader: 'none',
			opacity: 1,
			width: '97.6%',
			flgAdd: true,
			dispReport: '',
			src: require('./../images/blank.png'),
		}
	}

	theadScroll = (e) => {
		$('.tableHeadReportDiv').prop('scrollLeft', e.target.scrollLeft);
	}

	componentDidMount() {
		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);

		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.get(httpURL + '/a/ipo/dispreport/list', {
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === "Success") {
				this.setState({ dispReport: response.data.dispReport })
				dispReport = this.state.dispReport;
				console.log(response.data.dispReport);
				this.setDispReportTable();
				this.setState({loader:'none', opacity:1, disabled:false});
			}
			else {
				toast.error(response.data.SvcMsg)
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.CSURL;
					return false;
				}
				this.setState({loader:'none', opacity:1});
			}
		}).catch((e) => {
			toast.error("Service failed " + e);
		});
	}

	changeBuyerDeliveryDt = () => {
		var filterBuyDelDate = $('#filterBuyDelDate').val().trim();
		dispReport = [];
		var list = this.state.dispReport;

		if (filterBuyDelDate != '') {
			for (var i = 0; i < list.length; i++) {
				if (list[i].buyerDeliveryDt.includes(filterBuyDelDate)) {
					dispReport.push(list[i]);
					this.setDispReportTable();
				}
				else {
					this.setDispReportTable();
				}
			}
		}
		else {
			dispReport = this.state.dispReport;
			this.setDispReportTable();
		}
	}

	setDispReportTable = () => {
		$('#dispatchTableBody tr').remove();
		var table = document.getElementById('dispatchTable');
		var tbody = document.getElementById('dispatchTableBody');
		var filterIpo = $('#ipo').val().trim().toLowerCase();
		var wvr = $('#wvr').val().trim().toLowerCase();
		var comp = $('#company').val().trim().toLowerCase();
		var filterQuality = $('#filterQuality').val().trim().toLowerCase();
		var filterDesignColor = $('#filterDesignColor').val().trim().toLowerCase();
		var filterBpo = $('#filterBpo').val().trim().toLowerCase();


		for (var i = 0; i < dispReport.length; i++) {
			var ipo = dispReport[i].ipo;
			var bpoNo = dispReport[i].bpoNo;
			var company = dispReport[i].parentCompany;
			var weaver = dispReport[i].weaver;
			var style = dispReport[i].style;
			var color = dispReport[i].color;
			var designNoColor = dispReport[i].designNoColor;
			var quality = dispReport[i].quality;
			var yarnCount = dispReport[i].yarnCount;
			var width = dispReport[i].width;
			width = width == 0 ? '' : width;
			var buyerOrderQuantity = dispReport[i].buyerOrderQuantity;
			var buyerQuantityDispatch = dispReport[i].buyerQuantityDispatch;
			var balance = dispReport[i].balance;
			var recievedWeaverQuantity = dispReport[i].recievedWeaverQuantity;
			var weaverOrderQuantity = dispReport[i].weaverOrderQuantity;
			var balanceAtWeaver = dispReport[i].balanceAtWeaver;
			var stockBooked = dispReport[i].stockBooked;
			var stockLocation = dispReport[i].stockLocation;
			var completedCs = dispReport[i].completedCs;
			var workDone = dispReport[i].workDone;

			if (completedCs == null) {
				completedCs = '-';
			} else {
				if (completedCs == true) {
					completedCs = 'YES';
				} else {
					completedCs = 'NO';
				}
			}
			var completedWeaver = dispReport[i].completedWeaver;
			if (completedWeaver == null) {
				completedWeaver = '-';
			} else {
				if (completedWeaver == true) {
					completedWeaver = 'YES';
				} else {
					completedWeaver = 'NO';
				}
			}
			var buyerDeliveryDt = dispReport[i].buyerDeliveryDt === null ? '-' : dispReport[i].buyerDeliveryDt;
			var currentDeliveryDt = dispReport[i].currentDeliveryDt === null ? '-' : dispReport[i].currentDeliveryDt;
			var remarks = dispReport[i].remarks === null ? '-' : dispReport[i].remarks;
			var construction = dispReport[i].construction;

			var row = document.createElement('tr');
			if (ipo != null && ipo.toLowerCase().indexOf(filterIpo) === -1)
				continue;
			if (company != null && company.toLowerCase().indexOf(comp) === -1)
				continue;
			if (weaver != null && weaver.toLowerCase().indexOf(wvr) === -1)
				continue;
			if (designNoColor != null && designNoColor.toLowerCase().indexOf(filterDesignColor) === -1)
				continue;
			if (quality != null && quality.toLowerCase().indexOf(filterQuality) === -1)
				continue;
			if (bpoNo != null && bpoNo.toLowerCase().indexOf(filterBpo) === -1)
				continue;

			this.addTD(row, ipo, '');
			this.addTD(row, bpoNo, '');
			this.addTD(row, company, '');
			this.addTD(row, weaver, '');
			this.addTD(row, style + ' - ' + color, '');
			this.addTD(row, designNoColor, '');
			this.addTD(row, quality, '');
			this.addTD(row, yarnCount, '');
			this.addTD(row, width, '');
			this.addTD(row, construction, '');
			this.addTD(row, buyerQuantityDispatch + ' / ' + buyerOrderQuantity, 'text-right');
			this.addTD(row, balance, 'text-right');
			this.addTD(row, workDone, 'text-right');
			this.addTD(row, recievedWeaverQuantity + ' / ' + weaverOrderQuantity, 'text-right');
			this.addTD(row, balanceAtWeaver, 'text-right');
			this.addTD(row, stockBooked, 'text-right');
			this.addTD(row, stockLocation, '');
			this.addTD(row, completedCs, '');
			this.addTD(row, completedWeaver, '');
			this.addTD(row, buyerDeliveryDt, 'text-center');
			this.addTD(row, currentDeliveryDt, 'text-center');
			this.addTD(row, remarks, '');
			$(row).find("td").attr({ width: "100" });
			tbody.append(row);
		}
		table.append(tbody);
	}

	addTD(row, val, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		if (val == '-') {
			cell.style.textAlign = 'center';
		}
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}

	handleResize = () => {
		var width = ($('.tableHeadReportDiv').parent().width()) - 18;
		this.setState({ width: width })
	}
	sortAscByComp = () => {
		if (sortVal != 'aspo') {
			sortVal = 'aspo';
			$("#poAsDtIcon").css("color", "white");
			$("#poDsDtIcon").css("color", "#f1f1f1");
			$("#deliveryAsDtIcon").css("color", "#f1f1f1");
			$("#deliveryDsDtIcon").css("color", "#f1f1f1");

			var val1;
			var val2;

			for (var i = 0; i < dispReport.length - 1; i++) {
				val1 = dispReport[i].company;
				for (var j = i + 1; j < dispReport.length; j++) {
					val2 = dispReport[j].company;
					if (val1 > val2) {
						var tmp = dispReport[j];
						dispReport[j] = dispReport[i];
						dispReport[i] = tmp;
						val1 = dispReport[i].company;
					}
				}
			}
			this.setDispReportTable();
		}
	}

	sortAscByComp = () => {
		if (sortVal != 'dspo') {
			sortVal = 'dspo';
			$("#poAsDtIcon").css("color", "#f1f1f1");
			$("#poDsDtIcon").css("color", "white");
			$("#deliveryAsDtIcon").css("color", "#f1f1f1");
			$("#deliveryDsDtIcon").css("color", "#f1f1f1");

			var val1;
			var val2;

			for (var i = 0; i < dispReport.length - 1; i++) {
				val1 = dispReport[i].company;
				for (var j = i + 1; j < dispReport.length; j++) {
					val2 = dispReport[j].company;
					if (val1 < val2) {
						var tmp = dispReport[j];
						dispReport[j] = dispReport[i];
						dispReport[i] = tmp;
						val1 = dispReport[i].company;
					}
				}
			}
			this.setDispReportTable();
		}
	}
	sortAscByPo = () => {
		if (sortVal != 'aspo') {
			sortVal = 'aspo';
			$("#poAsDtIcon").css("color", "white");
			$("#poDsDtIcon").css("color", "#f1f1f1");
			$("#deliveryAsDtIcon").css("color", "#f1f1f1");
			$("#deliveryDsDtIcon").css("color", "#f1f1f1");

			var val1;
			var val2;

			for (var i = 0; i < dispReport.length - 1; i++) {
				val1 = dispReport[i].ipo;
				for (var j = i + 1; j < dispReport.length; j++) {
					val2 = dispReport[j].ipo;
					if (val1 > val2) {
						var tmp = dispReport[j];
						dispReport[j] = dispReport[i];
						dispReport[i] = tmp;
						val1 = dispReport[i].ipo;
					}
				}
			}
			this.setDispReportTable();
		}
	}

	sortDesByPo = () => {
		if (sortVal != 'dspo') {
			sortVal = 'dspo';
			$("#poAsDtIcon").css("color", "#f1f1f1");
			$("#poDsDtIcon").css("color", "white");
			$("#deliveryAsDtIcon").css("color", "#f1f1f1");
			$("#deliveryDsDtIcon").css("color", "#f1f1f1");

			var val1;
			var val2;

			for (var i = 0; i < dispReport.length - 1; i++) {
				val1 = dispReport[i].ipo;
				for (var j = i + 1; j < dispReport.length; j++) {
					val2 = dispReport[j].ipo;
					if (val1 < val2) {
						var tmp = dispReport[j];
						dispReport[j] = dispReport[i];
						dispReport[i] = tmp;
						val1 = dispReport[i].ipo;
					}
				}
			}
			this.setDispReportTable();
		}
	}

	render() {
		httpURL = window.httpURL;
		return (
			<div style={{ height: '100%' }}>
				<Header />
				<ToastContainer autoClose={2000} hideProgressBar />
				<div style={{ position: 'fixed', width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: this.state.loader, zIndex: 9999 }}>
					<img src={require("../images/loader.gif")} alt="Loader..." />
				</div>
				<div className="main">
					<div className="container-fluid">
						<div className="pull-left exportExcel">
							<ReactHTMLTableToExcel
								id="test-table-xls-button"
								className="btn btn-warning"
								table="dispatchTable"
								filename="tablexls"
								sheet="tablexls"
								buttonText="Export"
							/>
							<span className="BuyerDelDt"><input type="text" onChange={this.changeBuyerDeliveryDt} className="form-control inp-search" id="filterBuyDelDate" placeholder="Buyer Delivery Date"></input></span>
						</div>
						<div className="col-sm-12 padding-remove" style={{ overflowX: 'hidden' }}>
							<div className="tableHeadReportDiv" style={{ width: this.state.width }}>
								<table id="tableHeadReport" className="tableLayout1">
									<thead>
										<tr>
											<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>
												<div style={{ float: 'left', width: '80%' }}>
													<input type="text" onChange={this.setDispReportTable} className="form-control inp-search" id="ipo" placeholder="IPO" />
												</div>
												<div style={{ width: 10, float: 'left', marginLeft: 2, marginTop: 4 }}>
													<div className="assending">
														<span id="poAsDtIcon" onClick={this.sortAscByPo} className="glyphicon glyphicon-triangle-top"></span>
													</div>
													<div className="desending">
														<span id="poDsDtIcon" onClick={this.sortDesByPo} className="glyphicon glyphicon-triangle-bottom"></span>
													</div>
												</div>
											</th>
											<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>
												<input type="text" onChange={this.setDispReportTable} className="form-control inp-search" id="filterBpo" placeholder="BPO" />
											</th>
											<th style={{ width: 60, backgroundColor: "black", color: 'white' }}>
												<div style={{ float: 'left', width: '80%' }}>
													<input type="text" onChange={this.setDispReportTable} className="form-control inp-search" id="company" placeholder="Company" />
												</div>
												<div style={{ width: 10, float: 'left', marginLeft: 2, marginTop: 4 }}>
													<div className="assending">
														<span id="poAsDtIcon" onClick={this.sortAscByComp} className="glyphicon glyphicon-triangle-top"></span>
													</div>
													<div className="desending">
														<span id="poDsDtIcon" onClick={this.sortAscByComp} className="glyphicon glyphicon-triangle-bottom"></span>
													</div>
												</div>
											</th>
											<th style={{ width: 60, backgroundColor: "black", color: 'white' }}>
												<input type="text" onChange={this.setDispReportTable} className="form-control inp-search" id="wvr" placeholder="Weaver" />
											</th>
											<th style={{ width: 60, backgroundColor: "black", color: 'white' }}>Style-Color</th>
											<th style={{ width: 60, backgroundColor: "black", color: 'white' }}>
												<input type="text" onChange={this.setDispReportTable} className="form-control inp-search" id="filterDesignColor" placeholder="DesignNoColor" />
											</th>
											<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>
												<input type="text" onChange={this.setDispReportTable} className="form-control inp-search" id="filterQuality" placeholder="Quality" />
											</th>
											<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>YarnCount</th>
											<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>Width</th>
											<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>Construction</th>
											<th style={{ width: 60, backgroundColor: "black", color: 'white' }}>Buyer<br />Dispatch/Order</th>
											<th style={{ width: 30, backgroundColor: "black", color: 'white' }}>Balance</th>
											<th style={{ width: 30, backgroundColor: "black", color: 'white' }}>Work Done</th>
											<th style={{ width: 60, backgroundColor: "black", color: 'white' }}>Weaver<br />Dispatch/Order</th>
											<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>Balance <br />at Wvr</th>
											<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>Stock<br />Booked</th>
											<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>Stock <br />Location</th>
											<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>Completed <br />by CS</th>
											<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>Completed<br /> by Weaver</th>
											<th id="filterBuyDelDate" style={{ width: 40, backgroundColor: "black", color: 'white' }}>Buyer<br /> Del.Date</th>
											<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>Current<br /> Del.Date</th>
											<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>Remark</th>
										</tr>
									</thead>
								</table>
							</div>
							<div className="dispatchTableDiv" onScroll={this.theadScroll}>
								<div style={{ width: 2000 }}>
									<table id="dispatchTable" className="tableLayout">
										<colgroup>
											<col width="50" />
											<col width="40" />
											<col width="60" />
											<col width="60" />
											<col width="60" />
											<col width="60" />
											<col width="50" />
											<col width="50" />
											<col width="50" />
											<col width="50" />
											<col width="60" />
											<col width="30" />
											<col width="30" />
											<col width="60" />
											<col width="40" />
											<col width="50" />
											<col width="50" />
											<col width="40" />
											<col width="40" />
											<col width="40" />
											<col width="40" />
											<col width="40" />
										</colgroup>
										<thead style={{ display: 'none' }}>
											<tr>
												<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>IPO</th>
												<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>BPO</th>
												<th style={{ width: 60, backgroundColor: "black", color: 'white' }}>Company</th>
												<th style={{ width: 60, backgroundColor: "black", color: 'white' }}>Weaver</th>
												<th style={{ width: 60, backgroundColor: "black", color: 'white' }}>Style-Color</th>
												<th style={{ width: 60, backgroundColor: "black", color: 'white' }}>DesignNoColor</th>
												<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>Quality</th>
												<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>YarnCount</th>
												<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>Width</th>
												<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>Construction</th>
												<th style={{ width: 60, backgroundColor: "black", color: 'white' }}>Buyer<br />Dispatch/Order</th>
												<th style={{ width: 30, backgroundColor: "black", color: 'white' }}>Balance</th>
												<th style={{ width: 30, backgroundColor: "black", color: 'white' }}>Work Done</th>
												<th style={{ width: 60, backgroundColor: "black", color: 'white' }}>Weaver<br />Dispatch/Order</th>
												<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>Balance <br />at Wvr</th>
												<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>Stock<br />Booked</th>
												<th style={{ width: 50, backgroundColor: "black", color: 'white' }}>Stock <br />Location</th>
												<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>Completed <br />by CS</th>
												<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>Completed<br /> by Weaver</th>
												<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>Buyer<br /> Del.Date</th>
												<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>Current<br /> Del.Date</th>
												<th style={{ width: 40, backgroundColor: "black", color: 'white' }}>Remark</th>
											</tr>
										</thead>
										<tbody id="dispatchTableBody"></tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default DispatchSummary;
